import { DefaultTheme } from 'styled-components';

import {
  Colors,
  FontScales,
  FontWeights,
  TextAligns,
  TextTransforms,
  colors,
  fontScales,
  fontWeights,
  textAligns,
  textTransforms,
} from './config';

declare module 'styled-components' {
  export interface DefaultTheme {
    colors: Colors;
    fontScales: FontScales;
    fontWeights: FontWeights;
    maxWidth: string;
    transitionSpeed: string;
    headerHeight: string;
    settingsBarHeight: string;
    borderRadius: Record<string, string>;
    textTransforms: TextTransforms;
    textAligns: TextAligns;
  }
}

const theme: DefaultTheme = {
  colors,
  fontWeights,
  textTransforms,
  borderRadius: {
    base: '0.3rem',
    big: '0.6rem',
    big2: '1.6rem',
  },
  fontScales,
  maxWidth: '117rem',
  headerHeight: '5.9rem',
  settingsBarHeight: '4.5rem',
  transitionSpeed: '200ms',
  textAligns,
};

export { theme };
